module.exports = __webpack_public_path__ + "static/img/share.65f747d4.png";